module.exports = __webpack_public_path__ + "img/Prayer_Desktop.jpg";